module.exports = __webpack_public_path__ + "media/images/footer_page/about/about-4-317aadbae354fac85b9b92ba1c330608.svg";